import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import store from "./store";
import { Amplify } from "aws-amplify";

loadFonts();

async function initApp() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: "ap-south-1_MdPWcNLbh",
        userPoolClientId: "1b9mqsrmve8iribeman0d7qqbv",
        signUpVerificationMethod: "code",
        loginWith: {
          email: true,
        },
      },
    },

    API: {
      GraphQL: {
        endpoint:
          "https://pilklbq2trahnookvcsg7qmncy.appsync-api.ap-south-1.amazonaws.com/graphql",
        region: "ap-south-1",
        defaultAuthMode: "userPool",
      },
    },
  });
}

initApp().then(() => {
  createApp(App).use(router).use(store).use(vuetify).mount("#app");
});
